import { modalStyles } from '@/components/Modal/Modal.styles';

export const reviewModalModalDialogActionsStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: 2,
		width: '100%'
	},

	divider: modalStyles.edgeDivider,

	actions: {
		display: 'flex',
		gap: 1,
		width: '100%'
	},

	backButtonContainer: {
		flexGrow: 1
	},

	submitBtn: {
		'&.Mui-disabled': {
			backgroundColor: 'grey.300',
			opacity: 1
		}
	}
};
